module.exports = __webpack_public_path__ + "img/unit_SkyBlueMetallic.3ce3b51e.png";